.modal {
  min-width: 600px;
  max-width: 700px;
}

.body {
  margin: 32px 0 0 0;
}

.label {
  font-family: var(--font-semibold);
  font-size: 18px;
  margin-bottom: 8px;
}

.inputsContainer {
  padding-left: 0;
  padding-right: 0;
  margin-left: 40px;
  margin-right: 40px;
}

.row {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  width: 100%;
}

.input {
  flex: 1 1 0;
  width: 100%;
  box-sizing: border-box;
  font-size: 16px;
  padding: 12px 14px;
  border: 2px solid var(--gray-xl);
  border-radius: 8px;
  background: #fff;
  outline: none;
  transition: border-color 0.2s;
}

.dashboardUrlInput {
  margin-bottom: 32px;
}

.input:focus {
  border-color: var(--blue-l);
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
}

.cancel {
  min-width: 120px;
}

.continue {
  min-width: 120px;
}

.infoMessage {
  font-size: var(--font-semibold);
  font-size: 16px;
}

.exampleUrl {
  font-family: var(--font-bold);
  font-size: 14px;
  margin-top: 16px;
}
